'use client';

import Image from 'next/image';
import { HUB_EVENTS, pushDataLayer } from '@/lib/analytics';
import { ArrowUpRight } from './icons';
import Reveal from './reveal';
import type { HubContent } from '@/lib/content/hub';

export default function Shop({ copy }: { copy: HubContent['shop'] }) {
  return (
    <section id="shop" className="hub-section bg-yamal py-20 text-coal sm:py-28">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <Reveal className="flex flex-col items-center gap-10 text-center sm:flex-row sm:flex-wrap sm:justify-between sm:text-left">
          <div className="flex max-w-2xl flex-col items-center sm:items-start">
            <p className="hub-label-lg text-coal/70">{copy.eyebrow}</p>
            <h2 className="hub-display mt-4 text-[clamp(2.4rem,7vw,5rem)]">
              {copy.headline[0]}
              <br />
              {copy.headline[1]}
            </h2>
            <p className="mt-5 max-w-lg text-[17px] leading-relaxed text-coal/80">{copy.body}</p>
            <a
              href={copy.url}
              target="_blank"
              rel="noreferrer"
              onClick={() => pushDataLayer(HUB_EVENTS.NAV_CLICK, { section: 'shop' })}
              className="hub-display mt-8 inline-flex min-h-[52px] items-center gap-2 bg-coal px-8 py-4 text-[21px] tracking-[0.02em] text-cream transition-transform hover:-translate-y-0.5 active:translate-y-0"
            >
              {copy.cta}
              <ArrowUpRight className="size-[21px]" />
            </a>
          </div>
          <Image
            src="/hub/marks/shop-live-your-city.png"
            alt="American Eagle x Lamine Yamal, Live Your City"
            width={3319}
            height={1852}
            className="w-[240px] sm:w-[340px]"
          />
        </Reveal>
      </div>
    </section>
  );
}
